var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noData",class:{ 'is-top': _vm.isTop == true }},[_c('img',{staticClass:"img-noData",attrs:{"src":require('@/assets/noData.png'),"fit":"cover"}}),_c('p',[_vm._v("暂无数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }